var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import { fetchQuotaUsages, recalculateDiskUsage } from "@/api/users";
import { useConfig } from "@/composables/config";
import { useTaskMonitor } from "@/composables/taskMonitor";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import { bytesToString } from "@/utils/utils";
import { QuotaUsage } from "./Quota/model";
import QuotaUsageSummary from "@/components/User/DiskUsage/Quota/QuotaUsageSummary.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DiskUsageSummary',
    setup(__props) {
        const { config, isConfigLoaded } = useConfig(true);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const { isRunning: isRecalculateTaskRunning, waitForTask } = useTaskMonitor();
        const quotaUsages = ref();
        const errorMessage = ref();
        const isRecalculating = ref(false);
        const niceTotalDiskUsage = computed(() => {
            if (!currentUser.value || currentUser.value.isAnonymous) {
                return "Unknown";
            }
            return bytesToString(currentUser.value.total_disk_usage, true);
        });
        const isRefreshing = computed(() => {
            return isRecalculateTaskRunning.value || isRecalculating.value;
        });
        watch(() => isRefreshing.value, (newValue, oldValue) => {
            // Make sure we reload the user and the quota usages when the recalculation is done
            if (oldValue && !newValue) {
                const includeHistories = false;
                userStore.loadUser(includeHistories);
                loadQuotaUsages();
            }
        });
        function displayRecalculationForSeconds(seconds) {
            return __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve) => {
                    isRecalculating.value = true;
                    setTimeout(() => {
                        isRecalculating.value = false;
                        resolve();
                    }, seconds * 1000);
                });
            });
        }
        function onRefresh() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield recalculateDiskUsage({});
                    if (response.status == 200) {
                        // Wait for the task to complete
                        waitForTask(response.data.id);
                    }
                    else if (response.status == 204) {
                        // We cannot track any task, so just display the
                        // recalculation message for a reasonable amount of time
                        yield displayRecalculationForSeconds(30);
                    }
                }
                catch (e) {
                    errorMessage.value = errorMessageAsString(e);
                }
            });
        }
        function loadQuotaUsages() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield fetchQuotaUsages({ user_id: "current" });
                    quotaUsages.value = data.map((u) => new QuotaUsage(u));
                }
                catch (e) {
                    errorMessage.value = errorMessageAsString(e);
                }
            });
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield loadQuotaUsages();
        }));
        return { __sfc: true, config, isConfigLoaded, userStore, currentUser, isRecalculateTaskRunning, waitForTask, quotaUsages, errorMessage, isRecalculating, niceTotalDiskUsage, isRefreshing, displayRecalculationForSeconds, onRefresh, loadQuotaUsages, QuotaUsageSummary };
    }
});
